import * as React from 'react';
import { t } from '../../i18n';
import ResetPasswordContainer from '../../containers/Auth/ResetPassword';

const ResetPasswordPage = () => {
  return (
    <>
      <div className="mb-30">
        <h1 className="mb-10">{t('auth.resetPassword.title')}</h1>
        <p>{t('auth.resetPassword.description')}</p>
      </div>
      <ResetPasswordContainer />
    </>
  );
};

export default ResetPasswordPage;
